const getThemeFontFamilyClass = (fontPack?: number): string => {
  /*
		To use theme fonts via `font-family: var(--theme-font-head)` or `font-family: var(theme-font-body)`
		the following class must be added to the element for the selector to work.

		See `font-helmet.tsx` for font family initializations
	*/
  return `theme-font-${fontPack || 0}`;
};

export default getThemeFontFamilyClass;
